/**
 * Common Media Client Data Streaming Format
 *
 * @group CMCD
 *
 * @beta
 */
export var CmcdStreamingFormat;
(function (CmcdStreamingFormat) {
    /**
     * MPEG DASH
     */
    CmcdStreamingFormat["DASH"] = "d";
    /**
     * HTTP Live Streaming (HLS)
     */
    CmcdStreamingFormat["HLS"] = "h";
    /**
     * Smooth Streaming
     */
    CmcdStreamingFormat["SMOOTH"] = "s";
    /**
     * Other
     */
    CmcdStreamingFormat["OTHER"] = "o";
})(CmcdStreamingFormat || (CmcdStreamingFormat = {}));
//# sourceMappingURL=CmcdStreamingFormat.js.map